export default __webpack_public_path__ + "images/2d5056548f307600a7a1266859f1b978-x-close-circle.svg";